import type { CSSProperties } from 'react';

import type { CreateDrawerProps, CreateDrawerStep } from './createDrawer.types';
import { handleContentEnter } from './createDrawerKeys';
import { DrawerRail } from './DrawerRail';

const VISUALLY_HIDDEN: CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
};

/** The rail, the current step's content and the live region. */
export function DrawerBody({
  steps,
  cur,
  go,
  railNote,
  announcement,
  onCta,
  canContinue,
}: Pick<CreateDrawerProps, 'railNote' | 'announcement' | 'onCta'> & {
  steps: CreateDrawerStep[];
  cur: number;
  go: (i: number) => void;
  canContinue: boolean;
}) {
  return (
    <>
      <div className="nb-cdrawer-body">
        <DrawerRail steps={steps} cur={cur} go={go} railNote={railNote} />
        <div
          className="nb-cdrawer-content"
          onKeyDown={(e) => handleContentEnter(e, cur, steps.length - 1, onCta, go, canContinue)}
        >
          <div key={cur} className="nb-cdrawer-slide">
            {(steps[cur] ?? ({} as CreateDrawerStep)).content}
          </div>
        </div>
      </div>
      <div role="status" aria-live="polite" style={VISUALLY_HIDDEN}>
        {announcement}
      </div>
    </>
  );
}
